import { VueEditor } from 'vue2-editor'
// import { Api } from '@/service';
import vSelect from 'vue-select';
import  codes from '@/codes';

//restful api
import { notice as board } from '@/service/api/board'

export default {
  components: { VueEditor, vSelect },
  data : () => ({ codes, confirm: false, add: false, lock: true, model : { type : '' } }),
  methods: {
    cancel() { this.lock = true; },
    edit() { this.lock = false; },
    async remove() {
      try {
        // let rs = await Api.Manager_Call('board.notice', 'remove', { id : this.model.id });
        let rs = await board.deleteNotice({ id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          console.log("remove", 'failed', rs.reason, this.model.id)
          this.$toastr.e('remove', "failed")
        }
        this.list(); this.$emit('refresh')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      if(!(this.model.type && this.model.type.value ? this.model.type.value : this.model.type).trim()) { return this.$toastr.e('Solution is Require.'); }
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is Require.'); }

      // try {
      //   let model = Object.assign({}, this.model, { type : this.model.type.value ? this.model.type.value : this.model.type })
        // let rs = await Api.Manager_Call('board.notice', this.model.id ? 'update' : 'insert', model);
        // if(!rs.error) {
        //   this.$toastr.s('Saved', this.$route.name);
        //   this.$emit("refresh")
        //   // this.$router.push({ name : 'board_notice', params : { id : rs.body.id } });
        // } else {
        //   this.$toastr.s('Save', 'failed');
        // }

        try {
          let check_id = '';
          this.check_id = this.model.id ? 'update' : 'insert'

          if(check_id == 'update'){
            let model = Object.assign({}, this.model, { type : this.model.type.value ? this.model.type.value : this.model.type })
            let rs = await board.updateNotice(model);
            if(!rs.error) {
              this.$toastr.s('Saved', this.$route.name);
              this.$emit("refresh")
            } else {
              this.$toastr.s('Save', 'failed');
            }
          }else{
            let model = Object.assign({}, this.model, { type : this.model.type.value ? this.model.type.value : this.model.type })
            let rs = await board.insertNotice(model);
            if(!rs.error) {
              this.$toastr.s('Saved', this.$route.name);
              this.$emit("refresh")
            } else {
              this.$toastr.s('Save', 'failed');
            }
          }
        this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { this.$router.push({ name: 'board_notice'}); },
    async get(id = this.$route.params.id) {
      console.log('notice.detail.vue', 'load item', id);
      if(id !== 'add') {
        try {
          // let rs = await Api.Manager_Call('board.notice', 'detail', { id : id });
          let rs = await board.detailNotice({ id : id });
          this.model = Object.assign({}, this.model, rs.body );
          return;
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
      } else { this.add = true; }
      this.lock = false;
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created() { console.log('notice.detail.vue', 'created'); },
  destroyed() { console.log('notice.detail.vue', 'destroyed'); },
  mounted() { console.log('notice.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}